import type { FormProduct } from "@shared/types";

/**
 * Stable identity key for a selected product across the batch-import flow.
 *
 * `FormProduct.uuid` is optional; `id` is always present (inherited from
 * `Product`). Falling back to `id` prevents multiple uuid-less products from
 * collapsing onto the same `""` key in the modal's per-product maps, the
 * select-form toggle, and the configure collapsibles.
 */
export function getFormProductKey(product: FormProduct): string {
  return product.uuid ?? product.id;
}
